// @ts-nocheck
import { Game } from "../game-base";
import { TAU, clamp } from "../../util";

const iceGradCache = new Map();
const windGradCache = new Map();

function icePatchGradient(c, r) {
  const key = Math.round(r / 8);
  let g = iceGradCache.get(key);
  if (!g) {
    g = c.createRadialGradient(0, 0, r * 0.06, 0, 0, r);
    g.addColorStop(0, "rgba(232,244,255,0.62)");
    g.addColorStop(0.45, "rgba(168,212,240,0.38)");
    g.addColorStop(0.78, "rgba(140,210,255,0.22)");
    g.addColorStop(1, "rgba(100,180,230,0)");
    iceGradCache.set(key, g);
  }
  return g;
}

function windConeGradient(c, reach) {
  const key = Math.round(reach / 40);
  let g = windGradCache.get(key);
  if (!g) {
    g = c.createRadialGradient(0, 0, 8, 0, 0, reach);
    g.addColorStop(0, "rgba(220,248,255,0.38)");
    g.addColorStop(0.35, "rgba(180,230,255,0.32)");
    g.addColorStop(0.72, "rgba(140,210,255,0.22)");
    g.addColorStop(1, "rgba(100,180,240,0.02)");
    windGradCache.set(key, g);
  }
  return g;
}

function drawOutwardWindStreaks(c, reach, hw, t, pulse, alpha) {
  c.globalCompositeOperation = "lighter";
  const flow = (t * 340) % reach;
  for (let band = 0; band < 3; band++) {
    const bandOff = band * (reach / 3);
    for (let i = 0; i < 6; i++) {
      const edge = -hw + (i / 5) * hw * 2;
      const dist = ((flow + bandOff + i * 28) % (reach * 0.92)) + reach * 0.08;
      const streakLen = 36 + 22 * pulse;
      const x0 = Math.cos(edge) * Math.max(24, dist - streakLen);
      const y0 = Math.sin(edge) * Math.max(24, dist - streakLen);
      const x1 = Math.cos(edge) * dist;
      const y1 = Math.sin(edge) * dist;
      c.strokeStyle = `rgba(232,248,255,${alpha * (0.35 + 0.25 * pulse)})`;
      c.lineWidth = 2.5 - band * 0.5;
      c.beginPath();
      c.moveTo(x0, y0);
      c.lineTo(x1, y1);
      c.stroke();
      const ax = x1 - Math.cos(edge) * 10;
      const ay = y1 - Math.sin(edge) * 10;
      c.beginPath();
      c.moveTo(x1, y1);
      c.lineTo(ax + Math.cos(edge + 0.42) * 9, ay + Math.sin(edge + 0.42) * 9);
      c.moveTo(x1, y1);
      c.lineTo(ax + Math.cos(edge - 0.42) * 9, ay + Math.sin(edge - 0.42) * 9);
      c.stroke();
    }
  }
  for (let i = 0; i < 8; i++) {
    const a = -hw * 0.65 + (i / 7) * hw * 1.3;
    const dist = ((t * 280 + i * 44) % (reach * 0.85)) + reach * 0.12;
    c.fillStyle = `rgba(210,240,255,${alpha * (0.2 + 0.18 * pulse)})`;
    c.beginPath();
    c.arc(Math.cos(a) * dist, Math.sin(a) * dist, 2.5 + pulse, 0, TAU);
    c.fill();
  }
}

function drawIcePatchForming(c, ip, t) {
  const r = ip.r;
  const armTotal = 0.55;
  const prog = armTotal > 0 ? clamp(1 - ip.arm / armTotal, 0, 1) : 1;
  c.save();
  c.translate(ip.x, ip.y);
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = `rgba(168,212,240,${0.45 + 0.3 * Math.sin(t * 11)})`;
  c.lineWidth = 3.5;
  c.setLineDash([12, 8]);
  c.lineDashOffset = -t * 28;
  c.beginPath();
  c.arc(0, 0, r * prog, 0, TAU);
  c.stroke();
  c.setLineDash([]);
  const fill = c.createRadialGradient(0, 0, 0, 0, 0, r * prog);
  fill.addColorStop(0, `rgba(200,240,255,${0.14 + prog * 0.22})`);
  fill.addColorStop(1, "rgba(140,210,255,0)");
  c.fillStyle = fill;
  c.beginPath();
  c.arc(0, 0, r * prog, 0, TAU);
  c.fill();
  for (let i = 0; i < 6; i++) {
    const a = (i / 6) * TAU + t * 0.5;
    const cr = r * prog * (0.4 + (i % 3) * 0.1);
    c.strokeStyle = `rgba(232,244,255,${0.3 + 0.25 * prog})`;
    c.lineWidth = 2;
    c.beginPath();
    c.moveTo(Math.cos(a) * cr * 0.25, Math.sin(a) * cr * 0.25);
    c.lineTo(Math.cos(a) * cr, Math.sin(a) * cr);
    c.stroke();
  }
  c.restore();
}

/** Glacial Drift ice patches on the arena floor. */
Game.prototype.drawIcePatches = function () {
  const c = this.ctx;
  const t = this.nowS;
  for (const ip of (this.icePatches || [])) {
    if (ip.arm > 0) {
      drawIcePatchForming(c, ip, t);
      continue;
    }
    const pulse = 0.55 + 0.45 * Math.sin(t * 4 + ip.x * 0.01);
    c.save();
    c.translate(ip.x, ip.y);
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = 0.28 + pulse * 0.12;
    c.fillStyle = icePatchGradient(c, ip.r);
    c.beginPath();
    c.arc(0, 0, ip.r, 0, TAU);
    c.fill();
    c.globalAlpha = 1;
    c.strokeStyle = `rgba(232,244,255,${0.55 + pulse * 0.25})`;
    c.lineWidth = 3.5;
    c.beginPath();
    c.arc(0, 0, ip.r, 0, TAU);
    c.stroke();
    c.strokeStyle = `rgba(168,212,240,${0.35 + 0.2 * Math.sin(t * 5 + 1)})`;
    c.lineWidth = 1.5;
    c.setLineDash([6, 8]);
    c.beginPath();
    c.arc(0, 0, ip.r * 0.88, 0, TAU);
    c.stroke();
    c.setLineDash([]);
    c.globalCompositeOperation = "source-over";
    for (let i = 0; i < 3; i++) {
      const sx = Math.sin(t * 2.5 + i * 2.2) * ip.r * 0.28;
      const sy = Math.cos(t * 2 + i * 1.6) * ip.r * 0.2;
      c.fillStyle = `rgba(232,244,255,${0.18 + 0.12 * Math.sin(t * 6 + i)})`;
      c.beginPath();
      c.arc(sx, sy, ip.r * 0.08, 0, TAU);
      c.fill();
    }
    c.restore();
  }
};

function drawWindCone(c, x, y, ang, hw, reach, alpha, dashed) {
  c.save();
  c.translate(x, y);
  c.rotate(ang);
  c.globalCompositeOperation = "lighter";
  c.beginPath();
  c.moveTo(0, 0);
  c.arc(0, 0, reach, -hw, hw);
  c.closePath();
  c.globalAlpha = alpha;
  c.fillStyle = windConeGradient(c, reach);
  c.fill();
  c.globalAlpha = 1;
  c.strokeStyle = `rgba(200,240,255,${0.35 + alpha * 0.4})`;
  c.lineWidth = dashed ? 3 : 2.5;
  if (dashed) c.setLineDash([14, 10]);
  c.beginPath();
  c.moveTo(0, 0);
  c.lineTo(Math.cos(-hw) * reach, Math.sin(-hw) * reach);
  c.moveTo(0, 0);
  c.lineTo(Math.cos(hw) * reach, Math.sin(hw) * reach);
  c.stroke();
  if (dashed) c.setLineDash([]);
  c.restore();
}

/** Howling Gale windup preview from the boss during channel. */
Game.prototype.drawHowlingGaleTelegraph = function () {
  if (this.activeBossId?.() !== "vorathal") return;
  const boss = this.players.find(pl => pl.boss === "vorathal" && pl.alive);
  if (!boss || boss.channelSpell !== "boss_howling_gale") return;
  const c = this.ctx;
  const t = this.nowS;
  const pulse = 0.5 + 0.5 * Math.sin(t * 10);
  const reach = this.platformRadius || 400;
  const hw = vorathalGaleHalfAnglePreview(boss);
  const ang = boss.aim ?? boss.facing ?? -Math.PI / 2;
  drawWindCone(c, boss.x, boss.y, ang, hw, reach, 0.35 + pulse * 0.35, true);
};

function vorathalGaleHalfAnglePreview(boss) {
  if (boss.enraged) return 2.55;
  const frac = boss.maxHp > 0 ? boss.hp / boss.maxHp : 1;
  if (frac > 0.65) return 1.85;
  if (frac > 0.50) return 2.10;
  return 2.30;
}

/** Ix'tholoth Rift Collapse — void energy dragging everything OUTWARD toward the
 *  shrinking rim. Chevrons march from the core to the edge so the danger reads as
 *  "you are being pushed off", not "pulled to safety". */
Game.prototype.drawRiftCollapseField = function () {
  if (!this.ixtholothCollapseActive?.()) return;
  const c = this.ctx;
  const t = this.nowS;
  const reach = this.platformRadius || 400;
  if (reach <= 40) return;
  c.save();
  c.globalCompositeOperation = "lighter";
  // Rings collapsing inward toward the eye — reads as the floor caving in.
  const ringFlow = (t * 0.5) % 1;
  for (let k = 0; k < 3; k++) {
    const f = 1 - ((ringFlow + k / 3) % 1); // 1 → 0: rim to core
    const d = reach * (0.18 + 0.8 * f);
    const fade = Math.sin((1 - f) * Math.PI);
    c.globalAlpha = 0.06 + 0.22 * fade;
    c.strokeStyle = "rgba(168,72,214,1)";
    c.lineWidth = 2.2;
    c.beginPath();
    c.arc(0, 0, d, 0, TAU);
    c.stroke();
  }
  // Pulsing danger band hugging the (shrinking) rim.
  c.globalAlpha = 0.30 + 0.16 * Math.sin(t * 4);
  c.strokeStyle = "rgba(200,80,235,0.6)";
  c.lineWidth = 5;
  c.beginPath();
  c.arc(0, 0, reach * 0.96, 0, TAU);
  c.stroke();
  c.restore();
};

/** Howling Gale outward push cones. */
Game.prototype.drawWindFields = function () {
  const c = this.ctx;
  const t = this.nowS;
  for (const wf of (this.windFields || [])) {
    const pulse = 0.5 + 0.5 * Math.sin(t * 9 + wf.angle);
    const reach = this.platformRadius || 400;
    const hw = wf.halfW || 0.72;
    const ang = wf.angle || 0;
    const lifeFrac = clamp((wf.life || 0) / 3.5, 0, 1);
    const alpha = 0.82 + pulse * 0.18;
    drawWindCone(c, wf.x, wf.y, ang, hw, reach, alpha * (0.65 + lifeFrac * 0.35), false);
    c.save();
    c.translate(wf.x, wf.y);
    c.rotate(ang);
    drawOutwardWindStreaks(c, reach, hw, t, pulse, alpha);
    c.globalAlpha = 0.22 + pulse * 0.12;
    c.strokeStyle = "rgba(200,240,255,0.55)";
    c.lineWidth = 2;
    for (let i = 0; i < 4; i++) {
      const dist = reach * (0.25 + i * 0.2);
      c.beginPath();
      c.arc(0, 0, dist, -hw * 0.92, hw * 0.92);
      c.stroke();
    }
    c.restore();
  }
};

Game.prototype.humanOnIcePatchClient = function (p) {
  if (!p?.alive || p.falling) return false;
  const hx = p.x;
  const hy = p.y;
  const cr = p.radius || 23;
  for (const ip of this.icePatches || []) {
    if (ip.arm > 0) continue;
    const dx = hx - ip.x;
    const dy = hy - ip.y;
    if (Math.hypot(dx, dy) <= ip.r + cr * 0.35) return true;
  }
  return false;
};

Game.prototype.drawOnIceSparkles = function (c, p) {
  if (!this.humanOnIcePatchClient(p)) return;
  const t = this.nowS;
  c.save();
  c.globalCompositeOperation = "lighter";
  for (let i = 0; i < 4; i++) {
    const a = t * 4 + i * 1.5;
    const dist = p.radius * (0.6 + 0.2 * Math.sin(t * 5 + i));
    const px = Math.cos(a) * dist;
    const py = p.radius * 0.5 + Math.sin(a * 0.7) * p.radius * 0.3;
    c.fillStyle = `rgba(232,244,255,${0.45 + 0.3 * Math.sin(t * 8 + i)})`;
    c.beginPath();
    c.arc(px, py, 2 + Math.sin(t * 6 + i), 0, TAU);
    c.fill();
  }
  c.restore();
};

Game.prototype.spawnFrostStain = function (x, y, r) {
  if (!this.frostStains) this.frostStains = [];
  this.frostStains.push({ x, y, r, t: 0, maxLife: 16, life: 16 });
};

Game.prototype.updateFrostStains = function (dt) {
  if (!this.frostStains?.length) return;
  for (const st of this.frostStains) {
    st.t += dt;
    st.life = st.maxLife - st.t;
  }
  this.frostStains = this.frostStains.filter(st => st.life > 0);
};

Game.prototype.drawFrostStains = function () {
  const c = this.ctx;
  const t = this.nowS;
  for (const stain of this.frostStains || []) {
    const fade = clamp(stain.life / stain.maxLife, 0, 1);
    if (fade <= 0) continue;
    c.save();
    c.translate(stain.x, stain.y);
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = fade * 0.32;
    const g = c.createRadialGradient(0, 0, stain.r * 0.08, 0, 0, stain.r);
    g.addColorStop(0, "rgba(200,240,255,0.45)");
    g.addColorStop(0.65, "rgba(168,212,240,0.28)");
    g.addColorStop(1, "rgba(100,180,230,0)");
    c.fillStyle = g;
    c.beginPath();
    c.arc(0, 0, stain.r, 0, TAU);
    c.fill();
    c.globalAlpha = fade * 0.45;
    c.strokeStyle = "rgba(232,244,255,0.35)";
    c.lineWidth = 1.5;
    c.beginPath();
    c.arc(0, 0, stain.r * (0.88 + 0.04 * Math.sin(t * 2 + stain.x)), 0, TAU);
    c.stroke();
    c.restore();
  }
};
